module.exports = __webpack_public_path__ + "img/brook_rd_b2.2dd356f3.jpg";